// extracted by mini-css-extract-plugin
export var fadeIn = "_8x-0";